mutation userAccountDelete($eth_address: String!, $hash: String!) {
    userAccountDelete(eth_address: $eth_address, hash: $hash)
}
